import { render, staticRenderFns } from "./Voucher-Unit.vue?vue&type=template&id=bea0d5ae&scoped=true&"
import script from "./Voucher-Unit.vue?vue&type=script&lang=js&"
export * from "./Voucher-Unit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea0d5ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bea0d5ae')) {
      api.createRecord('bea0d5ae', component.options)
    } else {
      api.reload('bea0d5ae', component.options)
    }
    module.hot.accept("./Voucher-Unit.vue?vue&type=template&id=bea0d5ae&scoped=true&", function () {
      api.rerender('bea0d5ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4tkLcgfmR7M47/JS/comp/Voucher-Unit.vue"
export default component.exports